let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("1vP6v")).then(() => parcelRequire('9znD6'));